const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sort-arrow bottom-arrow",
    d: "M 41.513 61.694 L 27.244 75.963 V 5.588 c 0 -1.933 -1.567 -3.5 -3.5 -3.5 s -3.5 1.567 -3.5 3.5 v 70.375 L 5.975 61.694 c -1.366 -1.367 -3.583 -1.367 -4.95 0 c -1.367 1.366 -1.367 3.583 0 4.949 l 20.241 20.241 c 0.163 0.164 0.343 0.31 0.536 0.439 c 0.085 0.057 0.176 0.095 0.264 0.143 c 0.112 0.061 0.219 0.129 0.338 0.178 c 0.114 0.047 0.234 0.074 0.351 0.109 c 0.101 0.03 0.197 0.069 0.302 0.089 c 0.226 0.045 0.456 0.069 0.685 0.069 s 0.459 -0.024 0.685 -0.069 c 0.104 -0.021 0.201 -0.06 0.302 -0.089 c 0.118 -0.035 0.237 -0.062 0.351 -0.109 c 0.119 -0.049 0.226 -0.117 0.338 -0.178 c 0.088 -0.048 0.18 -0.087 0.264 -0.143 c 0.193 -0.129 0.373 -0.275 0.536 -0.439 l 20.241 -20.241 c 1.367 -1.366 1.367 -3.583 0 -4.949 C 45.096 60.328 42.88 60.327 41.513 61.694 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort-arrow top-arrow",
    d: "M 88.975 23.356 L 68.73 3.113 c -0.001 -0.001 -0.003 -0.002 -0.004 -0.003 c -0.633 -0.631 -1.506 -1.022 -2.471 -1.022 c -0.967 0 -1.843 0.393 -2.477 1.028 L 43.538 23.357 c -1.367 1.367 -1.367 3.583 0 4.95 c 1.366 1.366 3.582 1.367 4.949 0 l 14.269 -14.269 v 70.374 c 0 1.933 1.567 3.5 3.5 3.5 s 3.5 -1.567 3.5 -3.5 V 14.037 l 14.27 14.269 c 0.684 0.683 1.579 1.025 2.475 1.025 s 1.791 -0.342 2.475 -1.025 C 90.342 26.939 90.342 24.724 88.975 23.356 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.ac57895af71e072b22bc3d310e5e59fe.svg";
export { ForwardRef as ReactComponent };